module.exports = __webpack_public_path__ + "static/media/LogoFooter.7804b3c3.svg";